import { z } from 'zod';

import { MaintenanceDueStatusSchema } from './maintenance.schemas.js';

export const VehicleSummaryLastServiceOrderSchema = z.object({
  id: z.uuid(),
  status: z.string(),
  deliveredAt: z.iso.datetime().nullable(),
});

export type VehicleSummaryLastServiceOrder = z.infer<typeof VehicleSummaryLastServiceOrderSchema>;

export const VehicleSummaryPartInAttentionSchema = z.object({
  id: z.uuid(),
  partTypeName: z.string().nullable(),
  partPosition: z.string(),
  condition: z.string(),
});

export type VehicleSummaryPartInAttention = z.infer<typeof VehicleSummaryPartInAttentionSchema>;

export const VehicleSummaryPartsInAttentionSchema = z.object({
  count: z.number().int().nonnegative(),
  items: z.array(VehicleSummaryPartInAttentionSchema),
});

export type VehicleSummaryPartsInAttention = z.infer<typeof VehicleSummaryPartsInAttentionSchema>;

export const GetVehicleSummaryResponseSchema = z.object({
  customerVehicleId: z.uuid(),
  currentMileageMeters: z.number().int().nonnegative().nullable(),
  lastServiceOrder: VehicleSummaryLastServiceOrderSchema.nullable(),
  orderCount: z.number().int().nonnegative(),
  totalInvestedCents: z.string(),
  maintenanceStatus: MaintenanceDueStatusSchema,
  partsInAttention: VehicleSummaryPartsInAttentionSchema,
});

export type GetVehicleSummaryResponse = z.infer<typeof GetVehicleSummaryResponseSchema>;

export const FleetMaintenanceSummaryByStatusSchema = z.object({
  OVERDUE: z.number().int().nonnegative(),
  DUE_SOON: z.number().int().nonnegative(),
  OK: z.number().int().nonnegative(),
  UNKNOWN: z.number().int().nonnegative(),
});

export type FleetMaintenanceSummaryByStatus = z.infer<typeof FleetMaintenanceSummaryByStatusSchema>;

export const GetFleetMaintenanceSummaryResponseSchema = z.object({
  byStatus: FleetMaintenanceSummaryByStatusSchema,
});

export type GetFleetMaintenanceSummaryResponse = z.infer<
  typeof GetFleetMaintenanceSummaryResponseSchema
>;
